import type { PlayerScoring } from "@/pages/Rounds/constant";

type ScoringList = {
  listName: string;
  scoring: PlayerScoring[];
};

export const ScoringList: React.FC<ScoringList> = ({ listName, scoring }) => {
  return (
    <div>
      <div className="py-4 text-black">
        <h2 className="font-bold text-[20px] border-b-2 border-secondary py-4 pl-4">{listName}</h2>
        <ul>
          {scoring.map((item, index) => (
            <li
              key={`${index}:${item.name}`}
              className="flex justify-between text-[18px] py-2 border-b-2 border-gray-100"
            >
              <span className="text-black pl-6">{item.name}</span>
              <span className="text-black pr-6 font-bold">{item.score > 0 ? `+${item.score}` : item.score}pt</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
